import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {ChangeDetectorRef, Component} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {WebTerminalEntityModel} from "../web-terminal-entity.model";
import {WebTerminalType} from "../web-terminal.data";
import {License, Plugin} from "../../../config";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-web-terminal-edit-page",
    styleUrls: ["./web-terminal-edit-page.component.scss"],
    templateUrl: "./web-terminal-edit-page.component.html",
    providers: [provideEntityModel(WebTerminalEntityModel)]
})
export class WebTerminalEditPageComponent extends AbstractEditPage {
    WebTerminalType = WebTerminalType;
    Plugin = Plugin;
    License = License;

    constructor(public model: WebTerminalEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }
}
